import { addSafetyManagementForm, editSafetyManagementForm, getRiskColor } from "./actions.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import attachables from "./attachables.js";
import { tooltip as overallRiskTooltip } from "./overallRiskTooltip.js";
import { standardDateLocal } from "../../../utils.js";

export default [{
    "path": "/SafetyManagement/Forms",
    "component": { ...ItemListView },
    "name": "Safety Reporting Forms",
    "meta": {
        "app": "SafetyManagement",
        "sideNav": true,
        "appSwitcher": true,
        "appSwitcherPosition": 7,
        "sideNavPosition": 1,
        "sideNavSection": "Safety and Risk Management",
        "icon": "helmet-safety",
        "name": "Safety Reporting Forms",
        "tableSettings": "SafetyManagementForms",
        "dataPath": "SafetyManagement/Forms",
        "storeData": ["Database/DocumentTypes", "SafetyManagement/Categories"],
        "selectionRoute": "SafetyManagement/Forms/{ID}",
        "security": "General.SafetyManagementUser",
        "menuActions": [{
            "label": "Add Safety Reporting Form",
            "action": addSafetyManagementForm
        }]
    }
}, {
    "path": "/SafetyManagement/Forms/:id",
    "component": ItemView,
    "name": "Safety Reporting Form",
    "meta": {
        "app": "SafetyManagement",
        "name": "Safety Reporting Form",
        "dataPath": "SafetyManagement/Forms",
        "storeData": ["Database/DocumentTypes", "SafetyManagement/Categories"],
        "title": (item) => `Safety Reporting Form: ${item.Number}`,
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "md:col-span-2"
        }, {
            "label": "Category",
            "key": "Category"
        }, {
            "label": "Date Added",
            "key": "Date.Created",
            "type": "date"
        }, {
            "label": "Date Reviewed",
            "key": "Date.Reviewed",
            "type": "date"
        }, {
            "label": "Likelihood (Safety Manager)",
            "key": "SafetyManagerLikelihood"
        }, {
            "label": "Consequence (Safety Manager)",
            "key": "SafetyManagerConsequence"
        }, {
            "label": "Overall Risk",
            "tooltip": overallRiskTooltip,
            compute({ pageItem }) {
                return getRiskColor(pageItem?.SafetyManagerLikelihood?.split(" - ")[0], pageItem?.SafetyManagerConsequence?.split(" - ")[0]);
            }
        }, {
            "label": "Reportable Defect?",
            "tooltip": "Is this defect or occurrence classified as mandatory reportable?",
            "key": "ReportableDefect",
        }, {
            "label": "Voluntarily Submitted?",
            "tooltip": "Was this form voluntarily submitted?",
            "key": "VoluntarySubmission",
            show({ pageItem }) {
                return pageItem.ReportableDefect === "Yes";
            }
        }, {
            "label": "Date Submitted / Update Due / Closure ",
            "tooltip": "Enter the date this form was submitted",
            compute({ pageItem }) {
                const reportDate = new Date(pageItem.Date.ReportSubmitted);
                const updateDate = new Date(pageItem.Date.ReportSubmitted);
                updateDate.setDate(updateDate.getDate() + 30);
                const closureDate = new Date(pageItem.Date.ReportSubmitted);
                closureDate.setMonth(closureDate.getMonth() + 3);

                return `${reportDate.toLocaleDateString("en-gb", standardDateLocal)} / ${updateDate.toLocaleDateString("en-gb", standardDateLocal)} / ${closureDate.toLocaleDateString("en-gb", standardDateLocal)}`;
            },
            show({ pageItem }) {
                return pageItem.ReportableDefect === "Yes";
            }
        }],
        "menuActions": [{
            "label": "Edit Safety Reporting Form",
            "action": editSafetyManagementForm
        }],
        "attachedItems": {
            "Event Details": {
                "attachables": attachables
            }
        }
    }
}];
